
import { Options, Vue } from "vue-class-component";
import StockService from "../../service/StockService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, helpers, minValue, maxValue } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment, { min } from "moment";
import { useStore, ActionTypes } from "../../store";
import PaymentScreen from "../../components/PaymentScreen.vue";
import {
    ItemList,
    CounterEntry,
    PaymentListType,
} from "../pos_purchase_return/IPurchaseReceipt.js";
import StockTransferService from "../../service/StockTransferService.js";
import { watch } from 'vue';



@Options({
    title: "Inventory",
    components: {
        PaymentScreen,
    },
    watch: {
        lists: {
            handler(newLists) {
                this.totalUnits = newLists.reduce(
                    (acc, item) =>
                        acc +
                        (item.status == "Active"
                            ? parseFloat(item.qty)
                            : 0 || 0),
                    0
                );
                this.worthAmt = newLists.reduce(
                    (acc, item) =>
                        acc +
                        (parseFloat(
                            this.calculateItemWorth(
                                item.purchase_price,
                                item.qty,
                                item.pack_size
                            )
                        ) || 0),
                    0
                );
            },
            immediate: true,
        },

    },
})
export default class Stocks extends Vue {
    private store = useStore();
    private lists = [];
    private dialogTitle;
    private toast;
    private goToFirstLink = 0;
    private currentStoreID = 0;
    private stockService;
    private productDialog = false;
    private submitted = false;
    private deleteConfirmationDialog = false;
    private keyword = "";
    private checkPagination = true;
    private totalRecords = 0;
    private limit = 0;
    private totalUnits = 0;
    private worthAmt = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Initialization", to: "/home/initialization" },
        { label: "Inventory Management", to: "/store/stocks" },
    ];

    private productType;
    private brand;
    private brandSector;
    private category;
    private paymentDialog = false;
    private cashPaymentOption = true;
    private cardPaymentOption = true;
    private chequePaymentOption = true;
    private bankTransferPaymentOption = true;
    private payLaterOption = false;
    private paySupplierCredit = true;
    private supplierCreditAmount = 0;
    private paymentTitle = "Stock Adjustment Payment";
    private stockAdjustmentTypes;
    private historyData;
    private _stockVisibilityHandler: () => void = () => {};
    private confirmAdjDialog = false;
    private confirmAdjMessage = "";
    private confirmAdjReason = "";
    private confirmAdjNote = "";
    private _pendingAdjSave: (() => void) | null = null;
    private scanBuffer = "";

    // --- Stock freeze (soft-lock) state ---
    private _stockBeaconHandler: () => void = () => {};
    private currentUserId: number = 0;
    private currentBranchId: number = 0;
    private activeFreezeData: { product_id: number; batch_no: string; branch_id: number; user_id: number } | null = null;
    private validationPopup = false;
    private validationPopupMessage = "";
    private freezeRefreshTimer: any = null;

    private item = {
        id: 0,
        barcode: "",
        image: "default.jpg",
        sideEffects: "",
        packSelling: 0,
        tax_1: 0,
        tax_2: 0,
        tax_3: 0,
        status: "Active",
        profileID: 2,
        profileName: "",
        profileType: "",
    };

    private state = reactive({
        productName: "",
        generic: "",
        productType: 0,
        brand: 0,
        brandSector: 0,
        category: 0,
        stripSize: 0,
        packSize: 0,
        batchNo: "",
        barcode: "",
        unitQty: 0,
        packPurchase: 0,
        mRP: 0,
        disc: 0,
        expiryDate: "",
        storeLocation: "",
        supplier: "",
        minStock: 0,
        description: "",
        typeId: null as number | null,

        packOldPurchase: 0,
        oldUnitQty: 0,
        oldMRP: 0,
        supplierCredit: 0,
        paidUnitsInBatch: 0,   
        freeUnitsInBatch: 0,  
        paidUnitsRemaining: 0, 
    });

    private validationRules = {
        batchNo: {
            required: helpers.withMessage("Batch No is required", required),
        },
        unitQty: {
            required: helpers.withMessage("Unit Qty is required", required),
            minValue: helpers.withMessage("Unit Qty cannot be negative", minValue(0)),
        },
        packPurchase: {
            required: helpers.withMessage(
                "Unit Purchase Price is required",
                required
            ),
            minValue: helpers.withMessage(
                "Unit Purchase Price cannot be negative",
                minValue(0)
            ),
        },
        mRP: {
            required: helpers.withMessage("MRP is required", required),
            minValue: helpers.withMessage("MRP cannot be negative", minValue(0)),
        },
        description: {
            required: helpers.withMessage("Description is required", required),
        },
        disc: {
            required: helpers.withMessage("Disc % is required", required),
            minValue: helpers.withMessage("Disc % cannot be negative", minValue(0)),
            maxValue: helpers.withMessage("Disc % cannot be greater than 100", maxValue(100)),
        },
        expiryDate: {
            required: helpers.withMessage("Expiry Date is required", required),
        },
        typeId: {
            required: helpers.withMessage("Reason is required", required)
        }  
    };

    private counterEntry: CounterEntry[] = [];
    private paymentList: PaymentListType[] = [];

    private stockResponse;
    private storeList = [];
    private selectedStore = {
        id: 0,
    };
    private stockHistoryDialogTitle = "Stock History";
    private stockHistoryDialog = false;
    private goToSubFirstLink = 0;
    private checkSubPagination = true;
    private totalSubRecords = 0;
    private stockHistory: Array<{ [key: string]: any }> = [];
    private historyDetails = {
        old_values: "",
        new_values: "",
        changes: [{}],
    };

    private declineDialog       = false;
    private declineReason       = "";
    private decliningTransfer: any = null;

    private cancelDialog        = false;
    private cancelReason        = "";
    private cancellingTransfer: any = null;

    private dispatchDialog      = false;
    private dispatchingTransfer: any = null;
    private dispatchItems: Array<{
        transfer_item_id: number;
        product_name: string;
        batch_no: string;
        paid_qty: number;
        free_qty: number;
        qty: number;
        purchase_price: number;
        qtyError: string;
    }> = [];


    private transferDialog = false;
    private transferDetailDialog = false;
    private transferHistoryDialog = false;
    private transferConfirmDialog = false;
    private transferReceiveDialog = false;
    private discrepancyConfirmDialog = false;
    private discrepancyConfirmTransfer: any = null;
    private discrepancyConfirmItems: any[] = [];
    private discrepancyConfirmLoss = 0;
    private discrepancyConfirmNotes = "";
    private transferService;
    private activeTab = 0; 

    private outboundTransfers = [];
    private inboundTransfers  = [];
    private outboundTotal     = 0;
    private inboundTotal      = 0;
    private outboundDialog    = false;
    private inboundDialog     = false;
    private totalTransferRecords = 0;
    private transferKeyword = "";
    private transferStart = 0;
    private transferLimit = 25;
    private outboundFirst = 0;
    private inboundFirst  = 0;

    private hasActiveTransfer = false;
    private hasReceivedTransfer = false;

    private stockTransferHistory: any[] = [];
    private _transferChannel: BroadcastChannel | null = null;

    private transferState = reactive({
        toBranchId: null as number | null,
        notes: "",
        items: [] as Array<{
            stock_id: number;
            product_name: string;
            batch_no: string;
            available_qty: number;
            qty: number;
            purchase_price: number;
            effective_cost: number;
            expiry_date: string;
        }>,
    });

    private selectedTransfer: any = null;
    private receiveItems: Array<{
        product_id: number;
        product_name: string;
        batch_no: string;
        purchase_price: number;
        sent_qty: number;
        received_qty: number;
        missing_qty: number;
        damaged_qty: number;
        notes: string;
    }> = [];

    private branchList = [];

    private fieldsToCompare = [
        "barcode",
        "batch_no",
        "qty",
        "purchase_price",
        "mrp",
        "discount_percentage",
        "expiry_date",
    ];

    private stockAdj = {
        id: 0,
        receiptID: 0,
        profileID: 2,
        discount: 0,
        totalPaid: 0,
        totalTendered: 0,
        totalChange: 0,
        totalGrossAmt: 0,
        totalBill: 0,
        totalGoodsValue: 0,
        totalTax1: 0,
        totalTax2: 0,
        totalTax3: 0,
        totalTax: 0,
        description: "",
        billNo: "",
        paymentMethod: "",
        searchReceiptNo: "",
        status: "Active",
        type: "SAA",
    };

    private v$: any = useVuelidate(this.validationRules, this.state);

    private taxNames = [
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
        {
            taxName: "",
            show: false,
            optionalReq: "",
            taxValue: 0,
            accountHead: "",
            accountID: 0,
        },
    ];

    private outboundStatusFilter = '';
    private inboundStatusFilter  = '';

    private transferStatusOptions = [
        { label: 'All',              value: '' },
        { label: 'Requested',        value: 'Requested' },
        { label: 'Approved',         value: 'Approved' },
        { label: 'Declined',         value: 'Declined' },
        { label: 'In Transit',       value: 'InTransit' },
        { label: 'Discrepancy',      value: 'Discrepancy' },
        { label: 'Completed',        value: 'Completed' },
        { label: 'Cancelled',        value: 'Cancelled' },
    ];

    openCreateTransferTab() {
        window.open('/store/stock-transfer/create', '_blank');
    }

    //CALLING WHEN PAGINATION BUTTON CLICKS
    onPage(event) {
        this.loadList(event.first);
    }

    // onSubPage(event) {
    //     this.loadHistory();
    // }

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.stockService = new StockService();
        this.transferService = new StockTransferService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.loadList(0);
        window.addEventListener("keypress", this.handleKeypress);
        window.addEventListener("keydown", this.handleGlobalKeydown);

        // --- Stock freeze (soft-lock): release the lock if the tab/window is closed ---
        this._stockBeaconHandler = () => {
            if (this.activeFreezeData) {
                const url  = '/beacon/thaw_stock';
                const data = JSON.stringify(this.activeFreezeData);
                navigator.sendBeacon(url, new Blob([data], { type: 'application/json' }));
            }
        };

        // Keep the lock alive while the user is actively editing the form
        watch(
            () => ({ ...this.state }),
            () => {
                if (this.productDialog) {
                    this.refreshFreezeDebounced();
                }
            },
            { deep: true }
        );

        window.addEventListener('pagehide',     this._stockBeaconHandler);
        window.addEventListener('beforeunload', this._stockBeaconHandler);

        if (typeof BroadcastChannel !== 'undefined') {
            this._transferChannel = new BroadcastChannel('stock_transfer_channel');
            this._transferChannel.onmessage = (event) => {
                if (event.data?.type === 'transfer_created') {
                    this.toast.showSuccess(
                        `Transfer ${event.data.transfer_no} created. Refreshing list...`
                    );
                    this.loadOutboundList(0);
                    this.loadList(this.goToFirstLink); 
                }
            };
        }
    }

    beforeUnmount() {
        window.removeEventListener("keypress", this.handleKeypress);
        window.removeEventListener("keydown", this.handleGlobalKeydown);
        window.removeEventListener('pagehide',     this._stockBeaconHandler);
        window.removeEventListener('beforeunload', this._stockBeaconHandler);
        this._transferChannel?.close();
    }

    //ADD OR UPDATE THE ITEM VIA HTTP
    saveItem(isFormValid) {
        this.submitted = true;
        const adjustedPrice = this.adjustedPrice();

        if (isFormValid && adjustedPrice === 0) {
            // No change at all - simple update
            if (this.item.id != 0) {
                const expDate = this.state.expiryDate;
                if (typeof expDate !== "string") {
                    this.state.expiryDate = moment(expDate).format("YYYY-MM-DD");
                } else {
                    this.state.expiryDate = moment(expDate, "DD-MM-YYYY").format("YYYY-MM-DD");
                }
                this.stockService
                    .updateItem(this.item, this.state)
                    .then((res) => {
                        this.loadList(this.goToFirstLink);
                        this.toast.handleResponse(res);
                        // Backend releases the lock as part of update(); just clear it locally.
                        this.activeFreezeData = null;
                    });
            }
            this.productDialog = false;
            this.clearItems();

        } else if (isFormValid && adjustedPrice !== 0) {
            this.submitted = true;

            const qtyDiff   = this.state.unitQty - this.state.oldUnitQty;
            const priceDiff = this.state.packPurchase - this.state.packOldPurchase;

            if (this.state.typeId === 1) {
                const oldValue  = this.state.oldUnitQty    * this.state.packOldPurchase;
                const newValue  = this.state.unitQty        * this.state.packPurchase;
                const valueDiff = Math.abs(newValue - oldValue);

                if (this.state.typeId === 1 && this.isQtyChanged() && this.isPriceChanged()) {
                    const netAmount = (this.state.unitQty - this.state.oldUnitQty) * this.state.packPurchase
                                    + (this.state.packPurchase - this.state.packOldPurchase) * this.state.paidUnitsRemaining;
                    if (netAmount >= 0) {
                        this.stockAdj.type = "SAA";
                        this.paymentTitle  = "Purchase Correction (Additional Payment)";
                        this.cashPaymentOption  = false;
                        this.cardPaymentOption  = false;
                        this.bankTransferPaymentOption = false;
                        this.chequePaymentOption = false;
                        this.paySupplierCredit  = true;
                        this.supplierCreditAmount = this.state.supplierCredit;
                    } else {
                        this.stockAdj.type = "SAD";
                        this.paymentTitle  = "Purchase Correction (Refund from Supplier)";
                        this.cashPaymentOption  = false;
                        this.cardPaymentOption  = false;
                        this.bankTransferPaymentOption = false;
                        this.chequePaymentOption = false;
                        this.paySupplierCredit  = true;
                        this.supplierCreditAmount = 0;
                    }
                } else if (newValue > oldValue) {
                    this.stockAdj.type = "SAA";
                    this.paymentTitle  = "Purchase Correction (Additional Payment)";
                    this.cashPaymentOption  = false;
                    this.cardPaymentOption  = false;
                    this.bankTransferPaymentOption = false;
                    this.chequePaymentOption = false;
                    this.paySupplierCredit  = true;
                    this.supplierCreditAmount = this.state.supplierCredit;
                } else {
                    this.stockAdj.type = "SAD";
                    this.paymentTitle  = "Purchase Correction (Refund from Supplier)";
                    this.cashPaymentOption  = false;
                    this.cardPaymentOption  = false;
                    this.bankTransferPaymentOption = false;
                    this.chequePaymentOption = false;
                    this.paySupplierCredit  = true;
                    this.supplierCreditAmount = 0;
                }

                if (this.item.profileID == 2) this.paySupplierCredit = false;

                if (valueDiff === 0) {
                    this.setAccountingEntries();
                    this.stockAdj.totalPaid = 0;
                    this.stockAdj.totalTendered = 0;
                    this.stockAdj.totalChange = 0;
                    this.stockAdj.paymentMethod = "None";
                    this.stockAdj.discount = 0;
                    this.stockAdj.totalGrossAmt = 0;
                    this.stockAdj.totalBill = 0;
                    this.stockAdj.totalGoodsValue = 0;
                    this.stockAdj.totalTax1 = 0;
                    this.stockAdj.totalTax2 = 0;
                    this.stockAdj.totalTax3 = 0;
                    this.stockAdj.totalTax = 0;
                    const zeroPaymentList: PaymentListType[] = [];
                    const saveMethod = this.stockAdj.type === "SAA"
                        ? this.stockService.saveAddition
                        : this.stockService.saveDeduction;
                    saveMethod.call(this.stockService, this.stockAdj, zeroPaymentList, this.item, this.state, this.counterEntry)
                        .then((res) => {
                            if (res.alert == "info") {
                                this.clearAll();
                                if (this.stockResponse?.product_id && this.stockResponse?.batch_no) {
                                    this.stockService.thawStock(
                                        this.stockResponse.product_id,
                                        this.stockResponse.batch_no
                                    );
                                }
                            }
                            this.loadList(this.goToFirstLink);
                            this.toast.handleResponse(res);
                        });
                    this.productDialog = false;
                    this.submitted = false;
                    this.clearItems();
                } else {
                    const correctBillAmount = this.stockAdj.type === "SAD"
                        ? this.sadPaymentAmount
                        : this.saaPaymentAmount;
                    this.store.dispatch(ActionTypes.TOTAL_BILL, correctBillAmount);
                    this.paymentDialog = true;
                }
                return; 
            }

            if (qtyDiff > 0) {
                this.stockAdj.type = "SAA";
                this.paymentTitle = "Stock Adjustment Payment (Addition)";
                this.cashPaymentOption = false;
                this.cardPaymentOption = false;
                this.bankTransferPaymentOption = false;
                this.chequePaymentOption = false;
                this.payLaterOption = false;
                this.paySupplierCredit = true;
                this.supplierCreditAmount = this.state.supplierCredit;
            } else if (qtyDiff < 0) {
                this.stockAdj.type = "SAD";
                this.paymentTitle = "Stock Adjustment Payment (Deduction)";
                this.cashPaymentOption = false;
                this.cardPaymentOption = false;
                this.bankTransferPaymentOption = false;
                this.chequePaymentOption = false;
                this.payLaterOption = false;
                this.paySupplierCredit = true;
                this.supplierCreditAmount = 0;
            } else {
                if (priceDiff > 0) {
                    this.stockAdj.type = "SAA";  
                    this.paymentTitle = "Stock Adjustment Payment (Price Addition)";
                    this.cashPaymentOption = false;
                    this.cardPaymentOption = false;
                    this.bankTransferPaymentOption = false;
                    this.chequePaymentOption = false;
                    this.payLaterOption = false;
                    this.paySupplierCredit = true;
                    this.supplierCreditAmount = this.state.supplierCredit;
                } else {
                    this.stockAdj.type = "SAD";  
                    this.paymentTitle = "Stock Adjustment Payment (Price Deduction)";
                    this.cashPaymentOption = false;
                    this.cardPaymentOption = false;
                    this.bankTransferPaymentOption = false;
                    this.chequePaymentOption = false;
                    this.payLaterOption = false;
                    this.paySupplierCredit = true;
                    this.supplierCreditAmount = 0;
                }
            }

            if (this.item.profileID == 2) {
                this.paySupplierCredit = false;
            }

            const billAmount = this.stockAdj.type === "SAD"
                ? this.sadPaymentAmount
                : this.saaPaymentAmount;

            const bypassPayment = [2, 3, 4].includes(this.state.typeId as number);

            if (billAmount === 0 || bypassPayment) {
                this.setAccountingEntries();
                this.stockAdj.totalPaid = 0;
                this.stockAdj.totalTendered = 0;
                this.stockAdj.totalChange = 0;
                this.stockAdj.paymentMethod = "None";
                this.stockAdj.discount = 0;
                this.stockAdj.totalGrossAmt = billAmount;
                this.stockAdj.totalBill = 0;
                this.stockAdj.totalGoodsValue = 0;
                this.stockAdj.totalTax1 = 0;
                this.stockAdj.totalTax2 = 0;
                this.stockAdj.totalTax3 = 0;
                this.stockAdj.totalTax = 0;

                if (bypassPayment) {
                    const messageMap = {
                        2: 'Deducting Lost Stock will reduce inventory and record a Stock Loss on the Income Statement. Do you want to continue?',
                        3: 'Deducting Damaged Stock will reduce inventory and record a Stock Loss on the Income Statement. Do you want to continue?',
                        4: 'Stock Found will increase inventory quantity at zero cost. Do you want to continue?',
                    };
                    this.confirmAdjMessage = messageMap[this.state.typeId as number] ?? 'This adjustment has no payment. Do you want to continue?';

                    const zeroPamentList: PaymentListType[] = [];
                    const adjType = this.stockAdj.type;
                    this._pendingAdjSave = () => {
                        if (adjType === "SAA") {
                            this.stockService
                                .saveAddition(this.stockAdj, zeroPamentList, this.item, this.state, this.counterEntry)
                                .then((res) => {
                                    if (res.alert == "info") this.clearAll();
                                    this.loadList(this.goToFirstLink);
                                    this.toast.handleResponse(res);
                                });
                        } else {
                            this.stockService
                                .saveDeduction(this.stockAdj, zeroPamentList, this.item, this.state, this.counterEntry)
                                .then((res) => {
                                    if (res.alert == "info") this.clearAll();
                                    this.loadList(this.goToFirstLink);
                                    this.toast.handleResponse(res);
                                });
                        }
                        this.productDialog = false;
                        this.submitted = false;
                        this.clearItems();
                    };

                    this.confirmAdjDialog = true;
                    return;
                }

                const zeroPamentList: PaymentListType[] = [];
                if (this.stockAdj.type === "SAA") {
                    this.stockService
                        .saveAddition(this.stockAdj, zeroPamentList, this.item, this.state, this.counterEntry)
                        .then((res) => {
                            if (res.alert == "info") this.clearAll();
                            this.loadList(this.goToFirstLink);
                            this.toast.handleResponse(res);
                        });
                } else {
                    this.stockService
                        .saveDeduction(this.stockAdj, zeroPamentList, this.item, this.state, this.counterEntry)
                        .then((res) => {
                            if (res.alert == "info") this.clearAll();
                            this.loadList(this.goToFirstLink);
                            this.toast.handleResponse(res);
                        });
                }
                this.productDialog = false;
                this.submitted = false;
                this.clearItems();

            } else {
                this.store.dispatch(ActionTypes.TOTAL_BILL, billAmount);
                this.paymentDialog = true;
            }
        }
    }

    //FETCH THE DATA FROM SERVER
    loadList(page) {
        this.stockService
            .getStocks(this.keyword, this.selectedStore.id, page)
            .then((data) => {
                this.lists = data.records;
                //console.log("Frontend list ",this.lists);
                this.totalRecords = data.totalRecords;
                this.limit = data.limit;
                this.storeList = data.stores ?? [];
                this.currentStoreID = data.currentStoreID;
                this.productType = data.productType;
                this.brand = data.brand;
                this.brandSector = data.brandSector;
                this.category = data.category;

                // //taxNames
                this.taxNames = [];

                if (data.storeTaxes && data.storeTaxes.length > 0) {
                    this.taxNames.push({
                        taxName: data.storeTaxes[0].tax_name_1,
                        show: data.storeTaxes[0].show_1,
                        optionalReq: data.storeTaxes[0].required_optional_1,
                        taxValue:
                            data.storeTaxes[0].show_1 == "true"
                                ? Number(data.storeTaxes[0].tax_value_1)
                                : 0,
                        accountHead: data.storeTaxes[0].tax_name1?.chartName || '',
                        accountID: data.storeTaxes[0].link1,
                    });

                    this.taxNames.push({
                        taxName: data.storeTaxes[0].tax_name_2,
                        show: data.storeTaxes[0].show_2,
                        optionalReq: data.storeTaxes[0].required_optional_2,
                        taxValue:
                            data.storeTaxes[0].show_2 == "true"
                                ? Number(data.storeTaxes[0].tax_value_2)
                                : 0,
                        accountHead: data.storeTaxes[0].tax_name2?.chartName || '',
                        accountID: data.storeTaxes[0].link2,
                    });

                    this.taxNames.push({
                        taxName: data.storeTaxes[0].tax_name_3,
                        show: data.storeTaxes[0].show_3,
                        optionalReq: data.storeTaxes[0].required_optional_3,
                        taxValue:
                            data.storeTaxes[0].show_3 == "true"
                                ? Number(data.storeTaxes[0].tax_value_3)
                                : 0,
                        accountHead: data.storeTaxes[0].tax_name3?.chartName || '',
                        accountID: data.storeTaxes[0].link3,
                    });
                }
            });
    }

    clearItems() {
        this.item = {
            id: 0,
            barcode: "",
            image: "default.jpg",
            sideEffects: "",
            packSelling: 0,
            tax_1: 0,
            tax_2: 0,
            tax_3: 0,
            status: "Active",
            profileID: 2,
            profileName: "",
            profileType: "",
        };

        this.state.stripSize = 0;
        this.state.packSize = 0;
        this.state.batchNo = "";
        this.state.unitQty = 0;
        this.state.packPurchase = 0;
        this.state.mRP = 0;
        this.state.disc = 0;
        this.state.minStock = 0;
        this.state.expiryDate = "";
        this.state.storeLocation = "";
        this.state.supplier = "";
        this.state.typeId = null;
        this.state.description = "";
        this.hasActiveTransfer = false;
    }

    clearAll() {
        this.paymentList = [];

        this.stockAdj = {
            id: 0,
            receiptID: 0,
            profileID: 2,
            discount: 0,
            totalGrossAmt: 0,
            totalBill: 0,
            totalGoodsValue: 0,
            totalPaid: 0,
            totalTendered: 0,
            totalChange: 0,
            totalTax1: 0,
            totalTax2: 0,
            totalTax3: 0,
            totalTax: 0,
            description: "",
            billNo: "",
            searchReceiptNo: "",
            paymentMethod: "",
            status: "Active",
            type: "",
        };

        // this.itemScanBox = "";
        // this.state.selectedProfile = "";
        // this.state.selectedProfileType = "";
        // this.invoiceDiscount = "";
    }

    fixDigits(amt) {
        return Number(amt).toFixed(2);
    }

    formatExpiry(date) {
        return moment(date).format("DD-MM-YYYY");
    }

    formatDateTime(date) {
        return moment(date).format("DD-MM-YYYY hh:mm A");
    }

    formatHistoryAction(action: string): string {
        if (!action) {
            return '';
        }
        return action
            .replace(/([A-Z])/g, ' $1')
            .replace(/^\s+/, '')
            .replace(/\b\w/g, (c) => c.toUpperCase());
    }

    calculateItemWorth(purchasePrice, qty, packSize) {
        let amount = 0;

        if (packSize > 0) {
            amount = (qty / packSize) * purchasePrice;
        }

        return amount;
    }

    loadSearchData() {
        this.submitted = true;
        if (this.keyword) {
            this.goToFirstLink = 0;
            this.loadList(0);
        }
    }

    getDateAfterMonths(months, dates) {
        const date = new Date();
        date.setMonth(date.getMonth() + months); // Add months to current date
        date.setDate(date.getDate() + dates); // Add months to current date
        return date; // Return in YYYY-MM-DD format
    }

    cleanSearchData() {
        this.submitted = true;
        this.keyword = "";
        this.goToFirstLink = 0;
        this.loadList(0);
    }

    loadHistory() {
        this.stockService
            .getHistory(this.historyData, this.goToSubFirstLink)
            .then((res) => {
                if (res && res.records != null) {
                    this.stockHistory = res.records;
                    this.totalSubRecords = res.totalRecords;
                    this.checkSubPagination = res.totalRecords > this.limit;

                    this.stockHistory.forEach((item) => {
                        var tempArray = <any>[];
                        const oldValues = JSON.parse(item.old_values);
                        const newValues = JSON.parse(item.new_values);
                        this.fieldsToCompare.forEach((field) => {
                            if (
                                newValues[field] &&
                                oldValues[field] !== newValues[field]
                            ) {
                                const isQtyField = field === "qty";
                                tempArray.push({
                                    field: field,
                                    old: isQtyField
                                        ? Number(oldValues[field]).toFixed(0)
                                        : oldValues[field],
                                    newValue: isQtyField
                                        ? Number(newValues[field]).toFixed(0)
                                        : newValues[field],
                                });
                            }
                        });
                        item.changes = tempArray;
                    });
                }
            });
    }

    showHistory(data) {
        this.submitted = false;
        this.stockHistoryDialogTitle = "Stock History - " + data.product_name;
        this.stockHistoryDialog = true;
        this.historyData = data;
        this.stockTransferHistory = [];

        this.loadHistory();
        this.loadStockTransferHistory(data.id);
    }

    loadStockTransferHistory(stockId: number) {
        this.transferService.getTransferHistoryForStock(stockId).then(res => {
            this.stockTransferHistory = res.records ?? [];
        });
    }

    get canEditStock(): boolean {
        const perms = this.store.getters.gerUserPermissions;
        if (!perms) return false;
        try {
            const permArray = typeof perms === 'string' ? JSON.parse(perms) : perms;
            if (!Array.isArray(permArray)) return false;
            // handles both array of objects {name: '...'} and array of strings
            return permArray.some((p) => 
                typeof p === 'string' ? p === 'stock_edit' : p?.name === 'stock_edit'
            );
        } catch {
            return false;
        }
    }

    editIem(data) {
        this.submitted = false;
        this.dialogTitle = "Update Stock Item - " + data.product_name;

        this.stockService.getItem(data).then((res) => {
            if (res && res.stocks != null) {
                const resStocks = res.stocks;

                // --- Stock freeze (soft-lock): another user is already editing this batch ---
                if (res.freeze_alert) {
                    this.validationPopupMessage = res.freeze_alert.msg;
                    this.validationPopup = true;
                    return;
                }

                this.productDialog = true;

                this.stockResponse = resStocks;
                this.currentBranchId = resStocks.branch_id;
                this.currentUserId   = resStocks.created_by ?? this.currentUserId;
                this.activeFreezeData = {
                    product_id: resStocks.product_id,
                    batch_no:   resStocks.batch_no,
                    branch_id:  resStocks.branch_id,
                    user_id:    this.currentUserId,
                };

                this.item.id = resStocks.id;
                this.item.packSelling = Number(resStocks.sale_price);
                this.item.status = resStocks.status;
                this.item.tax_1 = Number(resStocks.tax_1);
                this.item.tax_2 = Number(resStocks.tax_2);
                this.item.tax_3 = Number(resStocks.tax_3);

                this.item.barcode =
                    resStocks.barcode == null ? "" : resStocks.barcode;
                // this.state.description =
                //     resStocks.description == null ? "" : resStocks.description;
                this.item.image = resStocks.image;
                this.item.sideEffects =
                    resStocks.side_effects == null
                        ? ""
                        : resStocks.side_effects;

                this.state.productName = resStocks.product_name;
                this.state.generic = resStocks.generic;
                this.state.packSize = Number(resStocks.pack_size);
                this.state.stripSize = Number(resStocks.strip_size);

                this.state.productType = resStocks.type;
                this.state.brand = resStocks.brand;
                this.state.brandSector = resStocks.brand_sector;
                this.state.category = resStocks.category;
                this.state.batchNo = resStocks.batch_no;
                this.state.unitQty = Number(resStocks.qty);
                this.state.oldUnitQty = Number(resStocks.qty);

                this.state.packPurchase = Number(resStocks.purchase_price);
                this.state.packOldPurchase = Number(resStocks.purchase_price);

                this.state.mRP = Number(resStocks.mrp);
                this.state.oldMRP = Number(resStocks.mrp);

                this.item.profileID =
                    resStocks.supplier_details?.profiler_id ?? 2;
                this.item.profileName = resStocks.supplier_details?.name ?? "";
                this.item.profileType = "Supplier"; // No need to get from BE

                this.state.disc = Number(resStocks.discount_percentage);
                this.state.expiryDate = this.formatExpiry(
                    resStocks.expiry_date
                );

                this.state.supplier = resStocks.supplier;
                this.state.supplierCredit =
                    resStocks.supplier_details?.supplier_payable ?? 0;

                this.stockAdjustmentTypes = res.stockAdjustmentTypes;
                this.state.typeId = null;

                this.state.paidUnitsInBatch  = res.paidFreeSplit?.paid_qty ?? Number(resStocks.qty);
                this.state.freeUnitsInBatch  = res.paidFreeSplit?.free_qty ?? 0;
                this.state.paidUnitsRemaining = res.paidUnitsRemaining ?? Number(resStocks.qty);

                this.hasActiveTransfer = res.has_active_transfer ?? false;
                this.hasReceivedTransfer = res.has_received_transfer ?? false;

                if (res.freeze_alert) {
                    this.toast.handleResponse({
                        alert: res.freeze_alert.type,
                        msg:   res.freeze_alert.msg,
                    });
                }

            }
        });
    }

    handleClick() {
        if (this.item.status === "Active") {
            this.activateItem();
        } else {
            this.deleteItem();
        }
    }

    onSubHistoryPage(event) {
        this.goToSubFirstLink = event.first;
        this.loadHistory();
    }

    handleKeypress(event) {
        if (event.key !== "Enter") {
            this.scanBuffer += event.key;
        }
    }

    handleGlobalKeydown(event: KeyboardEvent) {

        if (this.validationPopup) {
            if (event.key === "Escape") {
                event.preventDefault();
                this.validationPopup = false;
            }
            return;
        }

        if (this.confirmAdjDialog) {
            if (event.key === "Enter") {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.proceedAdjSave();
            } else if (event.key === "Escape") {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.confirmAdjDialog = false;
            }
            return;
        }

        if (this.transferReceiveDialog) {
            if (event.key === "Escape") {
                event.preventDefault();
                this.transferReceiveDialog = false;
            }
            return;
        }
        if (this.transferDialog) {
            if (event.key === "Escape") {
                event.preventDefault();
                this.transferDialog = false;
            }
            return;
        }

        if (this.productDialog) {
            if (event.key === "Enter") {
                event.preventDefault();
                event.stopImmediatePropagation();
                (document.activeElement as HTMLElement)?.blur();
                setTimeout(() => {
                    if (this.checkChanges()) {
                        this.saveItem(!this.v$.$invalid);
                    }
                }, 50);
            } else if (event.key === "Escape") {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.closeEditDialog();
            }
            return;
        }

        if (event.key === "Enter") {
            this.loadList(this.goToFirstLink);
        }
    }

    confirmDeleteItem(data) {
        this.state.productName = data.product_name;
        this.item.id = data.id;
        this.item.status = "Deleted";
        this.deleteConfirmationDialog = true;
    }

    deleteItem() {
        this.deleteConfirmationDialog = false;
        this.item.status = "Deleted";
        this.stockService.deleteItem(this.item).then((res) => {
            this.loadList(0);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
        });
    }

    confirmActivateItem(data) {
        this.state.productName = data.product_name;
        this.item.id = data.id;
        this.item.status = "Active";
        this.deleteConfirmationDialog = true;
    }

    activateItem() {
        this.deleteConfirmationDialog = false;
        this.item.status = "Active";
        this.stockService.activateItem(this.item).then((res) => {
            this.loadList(0);
            //SHOW NOTIFICATION
            this.toast.handleResponse(res);
        });
    }

    getPackSellingPrice(data) {
        const tax_1 = Number(this.item.tax_1);
        const tax_2 = Number(this.item.tax_2);
        const tax_3 = Number(this.item.tax_3);
        const mrp = Number(this.state.mRP);

        const totalTax = tax_1 + tax_2 + tax_3;
        const avgTax = 100 + totalTax;
        const tax = (mrp / avgTax) * totalTax;
        const packPrice = (mrp - tax).toFixed(2);

        this.item.packSelling = Number(packPrice);

        return Number(packPrice);
    }

    get currency() {
        return this.store.getters.getCurrency;
    }

    isSpecial(item) {
        return item.status === "Deleted";
    }

    rowClass(item) {
        return { "delete-item-raw": this.isSpecial(item) };
    }

    adjustedPrice() {
        return (
            this.state.packPurchase * this.state.unitQty -
            this.state.packOldPurchase * this.state.oldUnitQty
        );
    }

    closeEditDialog() {
        // --- Stock freeze (soft-lock): release the lock when the user cancels ---
        clearTimeout(this.freezeRefreshTimer);
        if (this.stockResponse?.product_id && this.stockResponse?.batch_no) {
            this.stockService.thawStock(
                this.stockResponse.product_id,
                this.stockResponse.batch_no
            );
            this.activeFreezeData = null;
        }

        this.productDialog = false;
        this.submitted = false;
        this.clearItems();
    }

    // --- Stock freeze (soft-lock): catch-all release, fires on any dialog close (X, esc, backdrop) ---
    onProductDialogHide() {
        clearTimeout(this.freezeRefreshTimer);

        const freezeData = this.activeFreezeData;
        if (freezeData) {
            this.stockService.thawStock(
                freezeData.product_id,
                freezeData.batch_no
            );
            this.activeFreezeData = null;
            this.submitted = false;
            this.clearItems();
        }
    }

    // --- Stock freeze (soft-lock): keep the lock alive while the user is actively editing ---
    refreshFreezeDebounced() {
        const freezeData = this.activeFreezeData;
        if (!freezeData) return;

        clearTimeout(this.freezeRefreshTimer);
        this.freezeRefreshTimer = setTimeout(() => {
            this.stockService.refreshFreeze(
                freezeData.product_id,
                freezeData.batch_no
            ).then((res) => {
                if (res.expired) {
                    this.validationPopupMessage = res.msg;
                    this.validationPopup = true;
                    this.closeEditDialog();
                }
            });
        }, 2000);
    }

    closePaymentScreen() {
        this.paymentDialog = false;
    }

    getProceededPayments(paymentList) {
        this.paymentList = paymentList;
        const tenderedList = this.getTotalPaid(paymentList);
        this.stockAdj.totalPaid = Number(tenderedList[0]);
        this.stockAdj.totalTendered = Number(tenderedList[1]);
        this.stockAdj.totalChange = Number(tenderedList[2]);

        const payedMethod = this.getPaymentMethod(paymentList);
        this.stockAdj.paymentMethod = payedMethod.payMethod;

        this.stockAdj.discount = 0;

        const correctBillAmount = this.stockAdj.type === "SAD"
        ? this.sadPaymentAmount
        : this.saaPaymentAmount;

        this.stockAdj.totalGrossAmt = correctBillAmount;
        this.stockAdj.totalBill     = correctBillAmount;
        this.stockAdj.totalGoodsValue = this.totalGoodsValue;
        this.stockAdj.totalTax1 = this.totalTax1;
        this.stockAdj.totalTax2 = this.totalTax2;
        this.stockAdj.totalTax3 = this.totalTax3;
        this.stockAdj.totalTax = Number(
            this.totalTax1 + this.totalTax2 + this.totalTax3
        );

        this.setAccountingEntries();
        // switch between stock adjustment addition and deduction
        if (this.stockAdj.type == "SAA") {
            this.stockService
                .saveAddition(
                    this.stockAdj,
                    this.paymentList,
                    this.item,
                    this.state,
                    this.counterEntry
                )
                .then((res) => {
                    if (res.alert == "info") {
                        this.clearAll();
                        // --- Stock freeze (soft-lock): release the lock after a successful save ---
                        if (this.stockResponse?.product_id && this.stockResponse?.batch_no) {
                            this.stockService.thawStock(
                                this.stockResponse.product_id,
                                this.stockResponse.batch_no
                            );
                            this.activeFreezeData = null;
                        }
                    }

                    this.loadList(this.goToFirstLink);
                    this.toast.handleResponse(res);
                });
        } else {
            this.stockService
                .saveDeduction(
                    this.stockAdj,
                    this.paymentList,
                    this.item,
                    this.state,
                    this.counterEntry
                )
                .then((res) => {
                    if (res.alert == "info") {
                        this.clearAll();
                        // --- Stock freeze (soft-lock): release the lock after a successful save ---
                        if (this.stockResponse?.product_id && this.stockResponse?.batch_no) {
                            this.stockService.thawStock(
                                this.stockResponse.product_id,
                                this.stockResponse.batch_no
                            );
                            this.activeFreezeData = null;
                        }
                    }

                    this.loadList(this.goToFirstLink);
                    this.toast.handleResponse(res);
                });
        }

        this.paymentDialog = false;
        this.submitted = false;
        this.productDialog = false;
        this.clearItems();
    }

    setAccountingEntries() {
        this.counterEntry = [];

        if (this.state.typeId === 1) {
            const qtyChanged = this.state.unitQty !== this.state.oldUnitQty;
            const priceDiff  = this.state.packPurchase - this.state.packOldPurchase;
            const qtyDiff    = this.state.unitQty - this.state.oldUnitQty;

            let amount: number;
            let invType: "Debit" | "Credit";
            let payType: "Debit" | "Credit";

            if (!qtyChanged && priceDiff !== 0) {
                amount  = Math.abs(priceDiff) * this.state.paidUnitsRemaining;
                invType = priceDiff > 0 ? "Debit"  : "Credit";
                payType = priceDiff > 0 ? "Credit" : "Debit";
            } else if (qtyChanged && priceDiff !== 0) {
                const signedQtyChange  = qtyDiff * this.state.packPurchase;
                const signedPriceCorr  = priceDiff * this.state.paidUnitsRemaining;
                const net = signedQtyChange + signedPriceCorr;
                if (Math.abs(net) < 0.001) return;
                amount  = Math.abs(net);
                invType = net > 0 ? "Debit"  : "Credit";
                payType = net > 0 ? "Credit" : "Debit";
            } else {
                const oldValue  = this.state.oldUnitQty * this.state.packOldPurchase;
                const newValue  = this.state.unitQty    * this.state.packPurchase;
                const valueDiff = newValue - oldValue;
                if (valueDiff === 0) return;
                amount  = Math.abs(valueDiff);
                invType = valueDiff > 0 ? "Debit"  : "Credit";
                payType = valueDiff > 0 ? "Credit" : "Debit";
            }

            this.counterEntry.push({
                accountID: 3, accountHead: "Inventory",
                amount, type: invType,
            });
            this._pushPaymentEntries(payType, amount);
            return;
        }

        if (this.stockAdj.type == "PUR") {
            this.counterEntry.push({
                accountID: 3,
                accountHead: "Inventory",
                amount: this.totalGross - this.totalDiscAmount,
                type: "Debit",
            });

            //ADDING TAXES
            if (this.totalTax1 != 0 && this.taxNames[0]) {
                this.counterEntry.push({
                    accountID: this.taxNames[0].accountID,
                    accountHead: this.taxNames[0].accountHead,
                    amount: this.totalTax1,
                    type: "Debit",
                });
            }

            if (this.totalTax2 != 0 && this.taxNames[1]) {
                this.counterEntry.push({
                    accountID: this.taxNames[1].accountID,
                    accountHead: this.taxNames[1].accountHead,
                    amount: this.totalTax2,
                    type: "Debit",
                });
            }

            if (this.totalTax3 != 0 && this.taxNames[2]) {
                this.counterEntry.push({
                    accountID: this.taxNames[2].accountID,
                    accountHead: this.taxNames[2].accountHead,
                    amount: this.totalTax3,
                    type: "Debit",
                });
            }

            if (this.totalBalance == 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Credit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Credit",
                    });
                }
            } else if (this.totalBalance == this.netTotal) {
                this.counterEntry.push({
                    accountID: 5,
                    accountHead: "Accounts payable",
                    amount: this.netTotal,
                    type: "Credit",
                });
            } else if (this.totalBalance > 0 && this.stockAdj.totalPaid > 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Credit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Credit",
                    });
                }

                this.counterEntry.push({
                    accountID: 5,
                    accountHead: "Accounts payable",
                    amount: this.totalBalance,
                    type: "Credit",
                });
            }
        } else if (this.stockAdj.type == "SAA") {

            const qtyChanged   = this.state.unitQty !== this.state.oldUnitQty;
            const priceChanged = this.state.packPurchase !== this.state.packOldPurchase;
            const qtyDiff      = this.state.unitQty - this.state.oldUnitQty;
            const priceDiff    = this.state.packPurchase - this.state.packOldPurchase;

            if (qtyChanged && !priceChanged) {

                const gainValue = qtyDiff * this.state.packPurchase;
                this.counterEntry.push({
                    accountID: 3, accountHead: "Inventory",
                    amount: gainValue, type: "Debit",
                });
                this.counterEntry.push({
                    accountID: 60, accountHead: "Stock Found",
                    amount: gainValue, type: "Credit",
                });

            } else if (!qtyChanged && priceChanged) {
                const priceAdj = Math.abs(priceDiff) * this.state.paidUnitsRemaining; 
                if (priceDiff > 0) {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceAdj, type: "Debit",
                    });
                    this._pushPaymentEntries("Credit", priceAdj);
                } else {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceAdj, type: "Credit",
                    });
                    this._pushPaymentEntries("Debit", priceAdj);
                }

            } else if (qtyChanged && priceChanged) {
                const priceCorrection = Math.abs(priceDiff) * this.state.oldUnitQty;
                const newUnitsValue   = Math.abs(qtyDiff) * this.state.packPurchase;

                if (priceDiff < 0) {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceCorrection, type: "Credit",
                    });
                    this._pushPaymentEntries("Debit", priceCorrection);
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: newUnitsValue, type: "Debit",
                    });
                    this.counterEntry.push({
                        accountID: 60, accountHead: "Stock Found",
                        amount: newUnitsValue, type: "Credit",
                    });

                } else {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceCorrection, type: "Debit",
                    });
                    this._pushPaymentEntries("Credit", priceCorrection);
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: newUnitsValue, type: "Debit",
                    });
                    this.counterEntry.push({
                        accountID: 60, accountHead: "Stock Found",
                        amount: newUnitsValue, type: "Credit",
                    });
                }
            }
        } else if (this.stockAdj.type == "RPU") {
            if (this.totalBalance == 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Debit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Debit",
                    });
                }
            } else if (this.totalBalance == this.netTotal) {
                this.counterEntry.push({
                    accountID: 4,
                    accountHead: "Accounts receivable",
                    amount: this.netTotal,
                    type: "Debit",
                });
            } else if (this.totalBalance > 0 && this.stockAdj.totalPaid > 0) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Debit",
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Debit",
                    });
                }

                this.counterEntry.push({
                    accountID: 4,
                    accountHead: "Accounts receivable",
                    amount: this.totalBalance,
                    type: "Debit",
                });
            }

            this.counterEntry.push({
                accountID: 3,
                accountHead: "Inventory",
                amount: this.totalGross - this.totalDiscAmount,
                type: "Credit",
            });

            //ADDING TAXES
            if (this.totalTax1 != 0 && this.taxNames[0]) {
                this.counterEntry.push({
                    accountID: this.taxNames[0].accountID,
                    accountHead: this.taxNames[0].accountHead,
                    amount: this.totalTax1,
                    type: "Credit",
                });
            }

            if (this.totalTax2 != 0 && this.taxNames[1]) {
                this.counterEntry.push({
                    accountID: this.taxNames[1].accountID,
                    accountHead: this.taxNames[1].accountHead,
                    amount: this.totalTax2,
                    type: "Credit",
                });
            }

            if (this.totalTax3 != 0 && this.taxNames[2]) {
                this.counterEntry.push({
                    accountID: this.taxNames[2].accountID,
                    accountHead: this.taxNames[2].accountHead,
                    amount: this.totalTax3,
                    type: "Credit",
                });
            }
        } else if (this.stockAdj.type == "SAD") {

            const qtyDiff     = this.state.unitQty - this.state.oldUnitQty;
            const priceDiff   = this.state.packPurchase - this.state.packOldPurchase;
            const qtyChanged  = qtyDiff !== 0;
            const priceChanged = priceDiff !== 0;

            if (qtyChanged && !priceChanged) {
                const lostValue = Math.abs(qtyDiff) * this.state.packPurchase;
                this.counterEntry.push({
                    accountID: 61, accountHead: "Stock Loss",
                    amount: lostValue, type: "Debit",
                });
                this.counterEntry.push({
                    accountID: 3, accountHead: "Inventory",
                    amount: lostValue, type: "Credit",
                });

            } else if (!qtyChanged && priceChanged) {
                const priceAdj = Math.abs(priceDiff) * this.state.paidUnitsRemaining; 
                if (priceDiff > 0) {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceAdj, type: "Debit",
                    });
                    this._pushPaymentEntries("Credit", priceAdj);
                } else {
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceAdj, type: "Credit",
                    });
                    this._pushPaymentEntries("Debit", priceAdj);
                }

            } else if (qtyChanged && priceChanged) {
                const lostQty         = Math.abs(qtyDiff);  
                const lostAtNewPrice  = lostQty * this.state.packPurchase;
                const priceCorrection = Math.abs(priceDiff) * this.state.oldUnitQty;

                if (priceDiff > 0) {
                    this.counterEntry.push({
                        accountID: 61, accountHead: "Stock Loss",
                        amount: lostAtNewPrice, type: "Debit",
                    });
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: lostAtNewPrice, type: "Credit",
                    });
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceCorrection, type: "Debit",
                    });
                    this._pushPaymentEntries("Credit", priceCorrection);

                } else {
                    this.counterEntry.push({
                        accountID: 61, accountHead: "Stock Loss",
                        amount: lostAtNewPrice, type: "Debit",
                    });
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: lostAtNewPrice, type: "Credit",
                    });
                    this.counterEntry.push({
                        accountID: 3, accountHead: "Inventory",
                        amount: priceCorrection, type: "Credit",
                    });
                    this._pushPaymentEntries("Debit", priceCorrection);
                }
            }
        }
        
    }

    private _pushPaymentEntries(type: "Debit" | "Credit", totalAmount: number) {
        const paid = this.stockAdj.totalPaid;
        const coveredByPayments = this.totalPaidCash + this.totalPaidBank
            + this.totalPaidSupplierCredit + this.totalPaidSupplierCreditClaim;
        const trueBalance = totalAmount - coveredByPayments;

        if (paid === 0) {
            const accountID   = type === "Credit" ? 5 : 4;
            const accountHead = type === "Credit" ? "Accounts Payable" : "Accounts Receivable";
            this.counterEntry.push({ accountID, accountHead, amount: totalAmount, type });

        } else {
            if (this.totalPaidCash > 0) {
                this.counterEntry.push({
                    accountID: 2, accountHead: "Cash in hand",
                    amount: this.totalPaidCash, type,
                });
            }
            if (this.totalPaidBank > 0) {
                this.counterEntry.push({
                    accountID: 8, accountHead: "Cash at bank",
                    amount: this.totalPaidBank, type,
                });
            }

            if (this.totalPaidSupplierCredit > 0) {
                if (type === "Credit") {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts Payable",
                        amount: this.totalPaidSupplierCredit, type: "Credit",
                    });
                } else {
                    this.counterEntry.push({
                        accountID: 4, accountHead: "Accounts Receivable",
                        amount: this.totalPaidSupplierCredit, type: "Debit",
                    });
                }
            }

            if (this.totalPaidSupplierCreditClaim > 0) {
                if (type === "Credit") {
                    this.counterEntry.push({
                        accountID: 4, accountHead: "Accounts Receivable",
                        amount: this.totalPaidSupplierCreditClaim, type: "Credit",
                    });
                } else {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts Payable",
                        amount: this.totalPaidSupplierCreditClaim, type: "Debit",
                    });
                }
            }

            if (trueBalance > 0) {
                const accountID   = type === "Credit" ? 5 : 4;
                const accountHead = type === "Credit" ? "Accounts Payable" : "Accounts Receivable";
                this.counterEntry.push({ accountID, accountHead, amount: trueBalance, type });
            }
        }
    }

    get saaPaymentAmount(): number {
        const qtyChanged  = this.state.unitQty !== this.state.oldUnitQty;
        const priceDiff   = this.state.packPurchase - this.state.packOldPurchase;
        const qtyDiff     = this.state.unitQty - this.state.oldUnitQty;

        if (this.state.typeId === 1) {
            if (!qtyChanged && priceDiff !== 0) {
                return Math.abs(priceDiff) * this.state.paidUnitsRemaining;
            }
            if (qtyChanged && priceDiff !== 0) {
                const qtyChangeValue  = qtyDiff * this.state.packPurchase;         
                const priceCorrection = priceDiff * this.state.paidUnitsRemaining; 
                return Math.abs(qtyChangeValue + priceCorrection);
            }
            const oldValue = this.state.oldUnitQty * this.state.packOldPurchase;
            const newValue = this.state.unitQty    * this.state.packPurchase;
            return Math.abs(newValue - oldValue);
        }

        const qtyDiffNonPC = this.state.unitQty - this.state.oldUnitQty;
        if (qtyDiffNonPC !== 0 && priceDiff !== 0) return Math.abs(priceDiff) * this.state.oldUnitQty;
        if (qtyDiffNonPC === 0 && priceDiff !== 0) return Math.abs(priceDiff) * this.state.paidUnitsRemaining;
        if (qtyDiffNonPC !== 0 && priceDiff === 0) return Math.abs(qtyDiffNonPC) * this.state.packPurchase;
        return this.totalGross;
    }

    get sadPaymentAmount(): number {
        const qtyChanged  = this.state.unitQty !== this.state.oldUnitQty;
        const priceDiff   = this.state.packPurchase - this.state.packOldPurchase;
        const qtyDiff     = this.state.unitQty - this.state.oldUnitQty;

        if (this.state.typeId === 1) {
            if (!qtyChanged && priceDiff !== 0) {
                return Math.abs(priceDiff) * this.state.paidUnitsRemaining;
            }
            if (qtyChanged && priceDiff !== 0) {
                const qtyChangeValue  = qtyDiff * this.state.packPurchase;        
                const priceCorrection = priceDiff * this.state.paidUnitsRemaining; 
                return Math.abs(qtyChangeValue + priceCorrection);
            }
            const oldValue = this.state.oldUnitQty * this.state.packOldPurchase;
            const newValue = this.state.unitQty    * this.state.packPurchase;
            return Math.abs(newValue - oldValue);
        }

        const qtyDiffNonPC = this.state.unitQty - this.state.oldUnitQty;
        if (qtyDiffNonPC !== 0 && priceDiff !== 0) return Math.abs(priceDiff) * this.state.oldUnitQty;
        if (qtyDiffNonPC === 0 && priceDiff !== 0) return Math.abs(priceDiff) * this.state.paidUnitsRemaining;
        if (qtyDiffNonPC !== 0 && priceDiff === 0) return Math.abs(qtyDiffNonPC) * this.state.packPurchase;
        return this.totalGross;
    }

    getTotalPaid(paymnetList) {
        let totalPaid = 0;
        let totalTendered = 0;
        let totalChange = 0;

        paymnetList.forEach((e) => {
            if (e.paymentType != "Tip") {
                totalPaid = totalPaid + Number(e.transTotalAmount);
                totalTendered = totalTendered + Number(e.tendered);
                totalChange = totalChange + Number(e.change);
            }
        });

        return [totalPaid, totalTendered, totalChange];
    }

    get totalGross() {
        return Math.abs(Number(this.adjustedPrice()));
    }

    get totalItemValue() {
        return this.state.mRP * this.state.unitQty;
    }

    get totalTax1() {
        let total = 0;
        return Number(total.toFixed(2));
    }

    get totalTax2() {
        let total = 0;
        return Number(total.toFixed(2));
    }

    get totalTax3() {
        let total = 0;
        return Number(total.toFixed(2));
    }

    get totalDiscAmount() {
        let total = 0;
        return total;
    }

    get netTotal() {
        return Number(
            (
                this.totalGross -
                this.totalDiscAmount +
                this.totalTax1 +
                this.totalTax2 +
                this.totalTax3
            ).toFixed(2)
        );
    }

    get totalGoodsValue() {
        return Number(this.totalItemValue.toFixed(2));
    }

    get totalBalance() {
        return this.netTotal - this.stockAdj.totalPaid;
    }

    get totalPaidCash() {
        let total = 0;
        this.paymentList.forEach((e) => {
            if (e.paymentType == "Cash") {
                total = total + Number(e.transTotalAmount);
            }
        });
        return total;
    }

    get totalPaidBank() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentType != "Cash"
                && e.paymentType != "Tip"
                && e.paymentTypeID != 5
                && e.paymentTypeID != 7
            ) {
                total = total + Number(e.transTotalAmount);
            }
        });
        return total;
    }

    get totalPaidSupplierCredit() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 5) {
                total = total + e.transTotalAmount;
            }
        });
        return total;
    }

    get totalPaidSupplierCreditClaim() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 7) {
                total = total + e.transTotalAmount;
            }
        });
        return total;
    }

    getPaymentMethod(paymentList) {
        let payMethod = "";
        let payMethodId = 0;

        if (paymentList.length == 0) {
            payMethod = "Pay Later";
            payMethodId = 2;
        } else if (paymentList.length == 1) {
            payMethod = paymentList[0].paymentType;
            payMethodId = paymentList[0].paymentTypeID;
        } else if (paymentList.length > 1) {
            payMethod = "Split";
            payMethodId = 0;
        }

        return { payMethod: payMethod, paymentMethodId: payMethodId };
    }

    checkChanges() {
        if (this.stockResponse && this.stockResponse.id) {
            // console.log(this.item.barcode + ' | ' +this.stockResponse.barcode
            //     + ' _____----___' +this.state.batchNo + ' | ' +this.stockResponse.batch_no
            //     + ' _____----___' +this.state.unitQty + ' | ' +this.stockResponse.qty
            //     + ' _____----___' +this.state.packPurchase + ' | ' +this.stockResponse.purchase_price
            //     + ' _____----___' +this.state.mRP + ' | ' +this.stockResponse.mrp
            //     + ' _____----___' +this.state.disc + ' | ' +this.stockResponse.discount_percentage
            //     + ' _____----___' +this.state.expiryDate + ' | ' + moment(this.stockResponse.expiry_date).format("DD-MM-YYYY"));

            if (
                this.item.barcode !== this.stockResponse.barcode ||
                this.state.batchNo !== this.stockResponse.batch_no ||
                Number(this.state.unitQty) !== Number(this.stockResponse.qty) ||
                Number(this.state.packPurchase) !==
                Number(this.stockResponse.purchase_price) ||
                Number(this.state.mRP) !== Number(this.stockResponse.mrp) ||
                Number(this.state.disc) !==
                Number(this.stockResponse.discount_percentage) ||
                this.state.expiryDate !==
                moment(this.stockResponse.expiry_date).format("DD-MM-YYYY")
            ) {
                return true;
            }
            return false;
        }
        return false;
        return true;
    }
    // update realtime
    setValueRealtime(savedItem, event) {
        savedItem.$model = event.value;
        savedItem.$touch();
        // --- Stock freeze (soft-lock): keep-alive while the user keeps typing ---
        this.refreshFreezeDebounced();
    }

    isQtyOnlyChange(): boolean {
        return this.state.unitQty !== this.state.oldUnitQty 
            && this.state.packPurchase === this.state.packOldPurchase;
    }

    isQtyChanged(): boolean {
        return this.state.unitQty !== this.state.oldUnitQty;
    }

    isPriceChanged(): boolean {
        return this.state.packPurchase !== this.state.packOldPurchase;
    }

    get isQtyDisabled() {
        return this.state.typeId === null || (this.hasReceivedTransfer && this.state.typeId === 1);
    }

    get isPriceDisabled() {
        if (this.state.typeId === null) return true;
        if (this.state.typeId === 2 || this.state.typeId === 3 || this.state.typeId === 4) return true;
        if (this.hasActiveTransfer || this.hasReceivedTransfer) return true;
        return false;
    }

    onReasonChange() {
        setTimeout(() => {
            this.state.unitQty = this.state.oldUnitQty;
            this.state.packPurchase = this.state.packOldPurchase;
            this.v$.unitQty.$reset();
            this.v$.packPurchase.$reset();
        }, 0);
    }
    
    get freeUnitsRemaining(): number {
        return Math.max(0, this.state.oldUnitQty - this.state.paidUnitsRemaining);
    }

    get lostQty(): number {
        return Math.max(0, this.state.oldUnitQty - this.state.unitQty);
    }

    get freeLostQty(): number {
        return Math.min(this.lostQty, this.freeUnitsRemaining);
    }

    get paidLostQty(): number {
        return Math.max(0, this.lostQty - this.freeLostQty);
    }

    get paidLostAmount(): number {
        return this.paidLostQty * this.state.packPurchase;
    }

    get adjustedPriceDisplay(): number {
        const qtyChanged  = this.state.unitQty !== this.state.oldUnitQty;
        const priceChanged = this.state.packPurchase !== this.state.packOldPurchase;

        if (this.state.typeId === 4) {
            return 0;
        }

        if ((this.state.typeId === 2 || this.state.typeId === 3) && qtyChanged) {
            return this.paidLostAmount;
        }
        
        if (!qtyChanged && priceChanged) {
            return Math.abs(this.state.packPurchase - this.state.packOldPurchase) 
                * this.state.paidUnitsRemaining;
        }
        return Math.abs(this.adjustedPrice());
    }

    proceedAdjSave() {
        this.confirmAdjDialog = false;
        if (this._pendingAdjSave) {
            this._pendingAdjSave();
            this._pendingAdjSave = null;
        }
    }

    validateQtyOnBlur() {
        const newVal = this.state.unitQty;
        const oldQty = this.state.oldUnitQty;

        if (this.state.typeId === 1) {
            const minAllowed = oldQty - this.state.paidUnitsRemaining;
            if (newVal < minAllowed) {
                this.toast.showError(
                    `Cannot deduct more than ${this.state.paidUnitsRemaining} paid unit(s). Free units cannot be deducted via Purchase Correction.`
                );
                this.state.unitQty = null as any;
                this.$nextTick(() => {
                    this.state.unitQty = minAllowed;
                });
            }
            return;
        }

        if (this.state.typeId === 4 && newVal < oldQty) {
            this.toast.showError('Stock Found can only increase quantity.');
            this.state.unitQty = null as any;
            this.$nextTick(() => { this.state.unitQty = oldQty; });
            return;
        }

        if ((this.state.typeId === 2 || this.state.typeId === 3) && newVal > oldQty) {
            this.toast.showError('Stock Loss/Damage cannot increase quantity.');
            this.state.unitQty = null as any;
            this.$nextTick(() => { this.state.unitQty = oldQty; });
            return;
        }
    }

    openOutboundTransferList() {
        this.outboundDialog = true;
        this.transferKeyword = '';
        this.outboundTransfers = [];

        this.transferService.getTransfers('', 0, 'out', 'Approved').then(data => {
            if (data.totalRecords > 0) {
                this.outboundStatusFilter = 'Approved';
                this.loadOutboundList(0);
                return;
            }
            this.transferService.getTransfers('', 0, 'out', 'InTransit').then(data2 => {
                if (data2.totalRecords > 0) {
                    this.outboundStatusFilter = 'InTransit';
                    this.loadOutboundList(0);
                    return;
                }
                this.transferService.getTransfers('', 0, 'out', 'Discrepancy').then(data3 => {
                    this.outboundStatusFilter = data3.totalRecords > 0 ? 'Discrepancy' : 'Requested';
                    this.loadOutboundList(0);
                });
            });
        });
    }

    openInboundTransferList() {
        this.inboundDialog = true;
        this.transferKeyword = '';
        this.inboundTransfers = [];

        this.transferService.getTransfers('', 0, 'in', 'Requested').then(data => {
            if (data.totalRecords > 0) {
                this.inboundStatusFilter = 'Requested';
                this.loadInboundList(0);
            } else {
                this.transferService.getTransfers('', 0, 'in', 'InTransit').then(data2 => {
                    this.inboundStatusFilter = data2.totalRecords > 0 ? 'InTransit' : 'Approved';
                    this.loadInboundList(0);
                });
            }
        });
    }

    loadOutboundList(page = 0) {
        this.outboundFirst = page;
        this.transferService.getTransfers(this.transferKeyword, page, 'out', this.outboundStatusFilter)
            .then(data => {
                this.outboundTransfers = data.records.map((t: any) => ({
                    ...t,
                    merged_item_count: this._mergeTransferItems(t.items ?? []).length,
                }));
                this.outboundTotal     = data.totalRecords;
                this.transferLimit     = data.limit;
                if (data.branches) this.branchList = data.branches;
            });
    }

    loadInboundList(page = 0) {
        this.inboundFirst = page;
        this.transferService.getTransfers(this.transferKeyword, page, 'in', this.inboundStatusFilter)
            .then(data => {
                this.inboundTransfers = data.records.map((t: any) => ({
                    ...t,
                    merged_item_count: this._mergeTransferItems(t.items ?? []).length,
                }));
                this.inboundTotal     = data.totalRecords;
                this.transferLimit    = data.limit;
            });
    }

    openTransferDialog(stockData) {
        this.transferService.checkFreeze(stockData.id).then(res => {
            if (res.frozen) {
                this.validationPopupMessage = res.msg;
                this.validationPopup = true;
                return;
            }
            this.transferDialog = true;
            this.transferState.items = [{
                stock_id:       stockData.id,
                product_name:   stockData.product_name,
                batch_no:       stockData.batch_no,
                available_qty:  Number(stockData.qty),
                qty:            0,
                purchase_price: Number(stockData.purchase_price),
                effective_cost: 0,  
                expiry_date:    stockData.expiry_date,
            }];
            this.branchList = (this.storeList || []).filter(
                (b: any) => b.id !== this.currentStoreID
            );
        });
    }

    submitTransfer() {
        if (!this.transferState.toBranchId) {
            this.toast.showError("Please select a destination branch.");
            return;
        }
        const validItems = this.transferState.items.filter(i => i.qty > 0);
        if (!validItems.length) {
            this.toast.showError("Enter quantity for at least one item.");
            return;
        }
        const payload = validItems.map(i => ({ stock_id: i.stock_id, qty: i.qty }));
        this.transferService.initiateTransfer(
            this.transferState.toBranchId,
            payload,
            this.transferState.notes
        ).then(res => {
            this.toast.handleResponse(res);
            if (res.alert === 'info') {
                this.transferDialog = false;
                this.loadList(this.goToFirstLink);
                this._refreshTransferDialogs();
            }
        });
    }

    dispatchTransfer(transfer) {
        this.transferService.dispatchTransfer(transfer.id, '').then(res => {
            this.toast.handleResponse(res);
            if (res.alert === 'info') this._refreshTransferDialogs();
        });
    }

    openReceiveDialog(transfer) {
        this.selectedTransfer = transfer;
        const prepared = (transfer.items ?? []).map((ti: any) => ({
            ...ti,
            sent_qty: ti.dispatched_qty ?? ti.sent_qty,
        }));
        this.receiveItems = this._mergeTransferItems(prepared).map((ti: any) => ({
            product_id:     ti.product_id,
            product_name:   ti.product?.product_name ?? '',
            batch_no:       ti.batch_no,
            purchase_price: Number(ti.purchase_price),
            sent_qty:       Number(ti.sent_qty),
            received_qty:   Number(ti.sent_qty),
            missing_qty:    0,
            damaged_qty:    0,
            notes:          '',
        }));
        this.transferReceiveDialog = true;
    }

    recalcReceived(item: any, changedField: 'missing' | 'damaged') {
        let missing = Number(item.missing_qty) || 0;
        let damaged = Number(item.damaged_qty) || 0;
        const sent  = Number(item.sent_qty);

        if (missing + damaged > sent) {
            if (changedField === 'damaged') {
                item.damaged_qty = Math.max(0, sent - missing);
                damaged = Number(item.damaged_qty);
            } else {
                item.missing_qty = Math.max(0, sent - damaged);
                missing = Number(item.missing_qty);
            }
            this.toast.showError(
                `Missing + Damaged cannot exceed dispatched qty (${sent}) for batch ${item.batch_no}.`
            );
        }

        item.received_qty = Math.max(0, sent - missing - damaged);
    }

    submitReceive() {
        for (const item of this.receiveItems) {
            const missing = Number(item.missing_qty) || 0;
            const damaged = Number(item.damaged_qty) || 0;

            if (missing + damaged > item.sent_qty) {
                this.toast.showError(`Missing + Damaged cannot exceed dispatched qty (${item.sent_qty}) for batch ${item.batch_no}.`);
                return;
            }

            if ((missing > 0 || damaged > 0) && !item.notes?.trim()) {
                this.toast.showError(`Discrepancy reason is required for batch ${item.batch_no}.`);
                return;
            }

            item.received_qty = Math.max(0, item.sent_qty - missing - damaged);
        }

        const payload: any[] = [];
        const originalItems = this.selectedTransfer?.items ?? [];

        for (const r of this.receiveItems) {
            const group = originalItems.filter((ti: any) =>
                ti.product_id === r.product_id &&
                ti.batch_no === r.batch_no &&
                Number(ti.purchase_price) === Number(r.purchase_price)
            );

            // Prefer free-stock items for missing/damaged allocation so free units are lost first.
            const sorted = [...group].sort((a: any, b: any) =>
                Number(b.sent_free_qty ?? 0) - Number(a.sent_free_qty ?? 0) ||
                Number(a.id) - Number(b.id)
            );

            let remainingMissing = Number(r.missing_qty) || 0;
            let remainingDamaged = Number(r.damaged_qty) || 0;

            for (const ti of sorted) {
                const dispatched = Number(ti.dispatched_qty ?? ti.sent_qty);
                const sentFree = Number(ti.sent_free_qty ?? 0);

                // damaged to free
                const damagedFree = Math.min(remainingDamaged, sentFree);
                let tiDamaged = damagedFree;
                remainingDamaged -= damagedFree;
                let freeRemaining = sentFree - damagedFree;

                // missing to remaining free
                const missingFree = Math.min(remainingMissing, freeRemaining);
                let tiMissing = missingFree;
                remainingMissing -= missingFree;
                freeRemaining -= missingFree;

                // paid capacity
                let paidRemaining = dispatched - sentFree;

                // damaged to paid
                const damagedPaid = Math.min(remainingDamaged, paidRemaining);
                tiDamaged += damagedPaid;
                remainingDamaged -= damagedPaid;
                paidRemaining -= damagedPaid;

                // missing to paid
                const missingPaid = Math.min(remainingMissing, paidRemaining);
                tiMissing += missingPaid;
                remainingMissing -= missingPaid;
                paidRemaining -= missingPaid;

                payload.push({
                    transfer_item_id: ti.id,
                    received_qty:     Math.max(0, dispatched - tiDamaged - tiMissing),
                    damaged_qty:      tiDamaged,
                    notes:            r.notes,
                });
            }

            if (remainingMissing > 0.001 || remainingDamaged > 0.001) {
                this.toast.showError(`Could not allocate missing/damaged for batch ${r.batch_no}.`);
                return;
            }
        }

        this.transferService.receiveTransfer(
            this.selectedTransfer.id,
            payload,
            ''
        ).then(res => {
            this.toast.handleResponse(res);
            if (res.alert === 'info') {
                this.transferReceiveDialog = false;
                this._refreshTransferDialogs();
                this.loadList(this.goToFirstLink);
            }
        });
    }

    completeTransfer(transfer) {
        this.transferService.getTransferDetail(transfer.id).then((res: any) => {
            const t = res.transfer;
            this.discrepancyConfirmTransfer = t;
            this.discrepancyConfirmItems = this._mergeTransferItems(t.items ?? []).map((item: any) => {
                const price = Number(item.purchase_price ?? item.effective_cost ?? 0);
                const paidLoss = Math.max(0, Number(item.sent_paid_qty ?? 0) - Number(item.received_paid_qty ?? 0));
                return {
                    ...item,
                    paid_loss_qty: paidLoss,
                    paid_loss_amt: paidLoss * price,
                };
            });
            this.discrepancyConfirmLoss = this.discrepancyConfirmItems.reduce(
                (sum, i) => sum + i.paid_loss_amt, 0
            );
            this.discrepancyConfirmNotes = "";
            this.discrepancyConfirmDialog = true;
        });
    }

    submitDiscrepancyCompletion() {
        if (!this.discrepancyConfirmTransfer) return;
        this.transferService.completeTransfer(this.discrepancyConfirmTransfer.id, this.discrepancyConfirmNotes)
            .then(res => {
                this.toast.handleResponse(res);
                if (res.alert === 'info') {
                    this.discrepancyConfirmDialog = false;
                    this._refreshTransferDialogs();
                }
            });
    }

    cancelTransfer(transfer) {
        this.cancellingTransfer = transfer;
        this.cancelReason        = "";
        this.cancelDialog        = true;
    }

    cancelTransferByReceiver(transfer) {
        this.cancellingTransfer = transfer;
        this.cancelReason        = "";
        this.cancelDialog        = true;
    }

    openDeclineDialog(transfer: any) {
        this.decliningTransfer = transfer;
        this.declineReason     = "";
        this.declineDialog     = true;
    }

    submitDecline() {
        if (!this.declineReason.trim()) {
            this.toast.showError("Decline reason is required.");
            return;
        }
        this.transferService.declineTransfer(this.decliningTransfer.id, this.declineReason)
            .then((res: any) => {
                this.toast.handleResponse(res);
                if (res.alert === 'info') {
                    this.declineDialog = false;
                    this._refreshTransferDialogs();
                }
            });
    }

    submitCancel() {
        if (!this.cancelReason.trim()) {
            this.toast.showError("Cancel reason is required.");
            return;
        }

        // Determine which cancel method to use based on transfer status
        const isReceiverCancel = this.cancellingTransfer.to_branch_id === this.currentBranchId;
        const cancelMethod = isReceiverCancel ? 'cancelTransferByReceiver' : 'cancelTransfer';

        this.transferService[cancelMethod](this.cancellingTransfer.id, this.cancelReason)
            .then((res: any) => {
                this.toast.handleResponse(res);
                if (res.alert === 'info') {
                    this.cancelDialog = false;
                    this._refreshTransferDialogs();
                    this.loadList(this.goToFirstLink);
                }
            });
    }

    approveTransfer(transfer: any) {
        this.transferService.approveTransfer(transfer.id)
            .then((res: any) => {
                this.toast.handleResponse(res);
                if (res.alert === 'info') this._refreshTransferDialogs();
            });
    }

    openDispatchDialog(transfer: any) {
        this.transferService.getTransferDetail(transfer.id).then((res: any) => {
            const t = res.transfer;
            this.dispatchingTransfer = t;
            this.dispatchItems = this._mergeTransferItems(t.items ?? []).map((ti: any) => ({
                transfer_item_id: ti.id,
                product_name:     ti.product?.product_name ?? '',
                batch_no:         ti.batch_no,
                paid_qty:         Number(ti.sent_paid_qty),
                free_qty:         Number(ti.sent_free_qty),
                qty:              Number(ti.sent_qty),
                purchase_price:   Number(ti.effective_cost ?? ti.purchase_price),
                qtyError:         '',
            }));
            this.dispatchDialog = true;
        });
    }

    submitDispatch() {
        const payload = (this.dispatchingTransfer?.items ?? []).map((ti: any) => ({
            transfer_item_id: ti.id,
            qty:              Number(ti.sent_qty),
        }));

        this.transferService.dispatchTransfer(this.dispatchingTransfer.id, payload, '')
            .then((res: any) => {
                this.toast.handleResponse(res);
                if (res.alert === 'info') {
                    this.dispatchDialog = false;
                    this._refreshTransferDialogs();
                    this.loadList(this.goToFirstLink);
                }
            });
    }

    viewTransferDetail(transfer) {
        this.transferService.getTransferDetail(transfer.id).then(res => {
            const t = res.transfer;
            t.items = this._mergeTransferItems(t.items ?? []);
            this.selectedTransfer  = t;
            this.transferDetailDialog = true;
        });
    }

    viewTransferDetailById(transferId: number) {
        this.transferService.getTransferDetail(transferId).then(res => {
            const t = res.transfer;
            t.items = this._mergeTransferItems(t.items ?? []);
            this.selectedTransfer     = t;
            this.transferDetailDialog = true;
        });
    }

    isOutbound(transfer): boolean {
        return transfer.from_branch_id === this.currentStoreID;
    }

    transferStatusColor(status: string): string {
        const map: Record<string, string> = {
            Requested:        '#f59e0b',
            Approved:         '#3b82f6',
            Declined:         '#6b7280',
            InTransit:        '#8b5cf6',
            Discrepancy:      '#f97316',
            Completed:        '#10b981',
            Cancelled:        '#ef4444',
        };
        return map[status] ?? '#6b7280';
    }

    private _refreshTransferDialogs() {
        if (this.outboundDialog) this.loadOutboundList(0);
        if (this.inboundDialog)  this.loadInboundList(0);
    }

    get canTransferStock(): boolean {
        const perms = this.store.getters.gerUserPermissions;
        if (!perms) return false;
        try {
            const permArray = typeof perms === 'string' ? JSON.parse(perms) : perms;
            if (!Array.isArray(permArray)) return false;
            return permArray.some((p) =>
                typeof p === 'string' ? p === 'stock_transfer' : p?.name === 'stock_transfer'
            );
        } catch {
            return false;
        }
    }

    private _mergeTransferItems(items: any[]): any[] {
        const map = new Map<string, any>();
        items.forEach(item => {
            const key = `${item.product_id}_${item.batch_no}_${item.purchase_price}`;
            if (map.has(key)) {
                const existing = map.get(key)!;
                existing.sent_qty      += Number(item.sent_qty);
                existing.sent_paid_qty += Number(item.sent_paid_qty);
                existing.sent_free_qty += Number(item.sent_free_qty);
                existing.received_qty  = item.received_qty != null
                    ? (Number(existing.received_qty ?? 0) + Number(item.received_qty))
                    : existing.received_qty;
                existing.missing_qty   += Number(item.missing_qty ?? 0);
                existing.damaged_qty   += Number(item.damaged_qty ?? 0);
                existing.sub_total     += Number(item.sub_total ?? 0);
            } else {
                map.set(key, { 
                    ...item,
                    sent_qty:      Number(item.sent_qty),
                    sent_paid_qty: Number(item.sent_paid_qty),
                    sent_free_qty: Number(item.sent_free_qty),
                    received_qty:  item.received_qty != null ? Number(item.received_qty) : null,
                    missing_qty:   Number(item.missing_qty ?? 0),
                    damaged_qty:   Number(item.damaged_qty ?? 0),
                    sub_total:     Number(item.sub_total ?? 0),
                });
            }
        });
        return Array.from(map.values());
    }

    onOutboundPage(event) {
        this.outboundFirst = event.first;
        this.loadOutboundList(event.first);
    }

    onInboundPage(event) {
        this.inboundFirst = event.first;
        this.loadInboundList(event.first);
    }

}
